import { Text, ToggleButtonGroup, VStack, makeUclComponent } from '@rbilabs/universal-components';

export const StyledDonationCard = VStack.withConfig({
  rounded: 'md',
  backgroundColor: Styles.color.cardBackground,
  padding: '$4',
});

export const StyledDonationTitle = Text.withConfig({
  variant: 'headerThree',
  marginBottom: '$0',
});

export const StyledDonationSubTitle = Text.withConfig({
  variant: 'copyTwo',
  fontSize: 'sm',
});

export const StyledToggleButtonGroup = makeUclComponent(ToggleButtonGroup).withConfig({
  marginTop: '$4',
});
